import { SearchItem, SearchResponseRecordType } from "@/types";

export interface Briefcase {
  // count: number;
  // nextPage: boolean;
  // previousPage: boolean;
  folders: Map<number, BriefcaseFolder>;
  foldersFlat: BriefcaseFolder[];
  itemIndex: Map<number, number[]>;
  defaultFolderId: number;
  currentFolderId: number;
  currentPage: number;
  pageSize: number;
  isLoading: boolean;
  lastUpdated: Date | null;
  itemBeingMoved: SearchItem | null; // The most recent item (un)starred.
}

export enum BriefcaseActions {
  ADD = "add",
  REMOVE = "remove",
  MOVE = "move",
}

export interface BriefcaseFolder {
  id: number;
  isDefault: boolean;
  name: string;
  items: SearchItem[];
  // Needed to add divider to combobox on Briefcase page.
  divider?: boolean;
  dossierUrl: string;
}

export interface BriefcaseItem {
  subscriptionModules: number[];
  id: number;
  briefcaseId: number;
  positionSummary: string;
  preferredNameDisplay: string;
  title: string;
  politicalParty: string;
  quickSummary: string;
  headshot: string;
  isFormer: boolean;
  addedToBriefcase: boolean;
  type: SearchResponseRecordType;
}

export interface BriefcasePayload {
  items: BriefcaseItem[];
  folderId?: number;
}
